export function StatCard({ label, value, sub, accent, icon, testID }) {
  return (
    <div
      data-testid={testID}
      className="rounded-2xl border border-rig-border bg-rig-surface p-5 transition-colors hover:border-rig-borderStrong"
    >
      <div className="flex items-start justify-between">
        <span className="font-display text-xs uppercase tracking-[0.18em] text-rig-dim">{label}</span>
        {icon}
      </div>
      <div
        className="mt-3 font-display text-4xl font-bold tracking-wide"
        style={{ color: accent || "#FFFFFF" }}
      >
        {value}
      </div>
      {sub && <div className="mt-1 text-sm text-rig-dim">{sub}</div>}
    </div>
  );
}
